import type { MorphemeCorpusFilter } from "@-/dev.improve.haniverse.lib.morpheme.corpus";
import { groupPrimitiveBuckets } from "#group-primitive-buckets";
import {
  primitiveGradingKey,
  type PrimitiveBrowseData,
  type PrimitiveGradingSelection,
} from "#primitive-browse-types";
import data from "#primitive-buckets.gen.json" with { type: "json" };

/** No database access or graph traversal, including on a cold/offline Browse open. */
export function getPrimitiveBrowseData(
  grading: PrimitiveGradingSelection,
  corpus: MorphemeCorpusFilter,
): PrimitiveBrowseData {
  const scope = data[primitiveGradingKey(grading)];
  if (scope === undefined) {
    throw new Error(`Missing bundled primitive scope: ${primitiveGradingKey(grading)}`);
  }
  if (corpus.includesAllGraphemes) {
    return scope.all;
  }
  // Corpus keys serialize script, bands, character cutoff, then the independent word cutoff.
  const band = grading.script === "simplified" ? "tier1" : "common";
  if (corpus.cacheKey.startsWith(`["${grading.script}",["${band}"],null,`)) {
    return scope.default;
  }
  // User-defined bands/cutoffs are dynamic. Only prune already-ranked direct parents and regroup;
  // never traverse the decomposition graph or query the static database on-device.
  return groupPrimitiveBuckets(
    scope.all.primitives.map((item) => ({
      ...item,
      compounds: item.compounds.filter((glyph) => corpus.isGraphemeInCorpus(glyph)),
    })),
  );
}
